import useMediaQuery, {
  MediaQueryEnum,
  MediaQueryKey,
} from 'use-media-antd-query';

export const useSmallScreen = (): boolean => {
  const colSize = useMediaQuery();
  return ['xs', 'sm'].includes(colSize);
};

export const isSmallScreen = () =>
  (['xs', 'sm'] as Array<MediaQueryKey>).some(
    (colSize) => window.matchMedia(MediaQueryEnum[colSize].matchMedia).matches
  );
